import React from 'react';
import { BrowserRouter as Router} from "react-router-dom";
import { CourseProvider} from "../components/provider/CourseContext"
import { UserProvider } from "../components/provider/UserContext";
import Page from '../components/Page';
import MainRoutes from "./MainRoutes";


import 'react-lazy-load-image-component/src/effects/blur.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'aos/dist/aos.css';
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
const App = () => {
  
  return (
    <Page>
      <Router>
        <UserProvider>
          <CourseProvider>
              <MainRoutes />
              <ToastContainer
                position="top-center"
                autoClose={3000}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnVisibilityChange
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
            />
          </CourseProvider>
        </UserProvider>
    
      </Router>
   </Page>
  );


};


export default App;
